module.exports = __webpack_public_path__ + "img/220fff7.jpg";